// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_DEe","cls2":"News-cls2_R7W News-cls1_DEe"};